// Admin bookmarks of the Applications Catalog (/portal/catalog).
// Public hosts are the ones configured in Nginx Proxy Manager (see components/onprem/servers.ts → publicHosts).
// Services without a proxy host link to the internal address (only reachable from the company network / VPN).
// Last updated: 2026-11-04.

export interface AdminLink {
  name: string;
  url: string;
  /** Short hint shown under the name */
  note?: string;
  /** true = link not confirmed yet (path or host still to verify) */
  verify?: boolean;
}

export interface AdminLinkGroup {
  title: string;
  links: AdminLink[];
}

const gc = (name: string, path = "") => `https://${name}.genesiscloud.cc${path}`;

export const adminLinkGroups: AdminLinkGroup[] = [
  {
    title: "Infrastructure & proxy",
    links: [
      { name: "Nginx Proxy Manager", url: gc("erprpx", "/nginx/proxy"), note: "Public hosts and TLS certificates (also reverse.genesiscloud.cc)" },
      { name: "Portainer", url: gc("portainer", "/#!/home"), note: "Containers of all Docker servers (also dev.portainer.genesiscloud.cc)" },
      { name: "Vault (Vaultwarden)", url: gc("vault", "/#/"), note: "Passwords – on dev-006" },
      { name: "PM2", url: "https://app.pm2.io/", note: "Node processes (cloud)" },
    ],
  },
  {
    title: "Monitoring",
    links: [
      { name: "Grafana", url: gc("monitor"), note: "Dashboards – dev-006" },
      { name: "Prometheus targets", url: "http://10.192.193.6:9090/targets", note: "Internal – no proxy host" },
      { name: "Blackbox exporter", url: "http://10.192.193.6:9115", note: "Job api-health-check – internal" },
      { name: "Node exporter (dev-006)", url: "http://10.192.193.6:9100/metrics", note: "Internal" },
    ],
  },
  {
    title: "AI platform",
    links: [
      { name: "semantic-api-dev Swagger", url: "http://10.192.193.8:8089/swagger/index.html", note: "Entry point for AI calls – dev-008, internal" },
      { name: "Operations Workspace", url: gc("workspace"), note: "Also ai.genesiscloud.cc" },
      { name: "AI Control Hub", url: gc("aicontrolhub") },
      { name: "LiteLLM", url: gc("litellm", "/ui"), note: "LLM gateway – dev-006" },
      { name: "Open WebUI (GPT)", url: "https://gpt.loacker.cc", note: "Production instance" },
      { name: "Open WebUI (GPT dev)", url: "https://gpt-dev.loacker.cc" },
      { name: "Flowise", url: gc("flow") },
      { name: "Langfuse", url: gc("langf"), note: "Not in the Nginx Proxy Manager list", verify: true },
      { name: "docling serve", url: "http://10.192.193.201:5001/ui/", note: "KI server atgolosai01 – internal" },
      { name: "n8n", url: gc("n8n"), note: "Automation – dev-008" },
    ],
  },
  {
    title: "Data & storage",
    links: [
      { name: "Qdrant", url: gc("qdrant", "/dashboard#/collections"), note: "Also qdrant-local.genesiscloud.cc" },
      { name: "Qdrant dev", url: gc("qdrant-dev", "/dashboard#/collections") },
      { name: "OpenSearch Dashboards", url: gc("vector"), note: "RAG index document_chunks" },
      { name: "RedisInsight", url: gc("redisin") },
      { name: "RustFS console (S3)", url: gc("objectdb") },
      { name: "RabbitMQ dev", url: gc("queue-dev"), note: "vhost /einv" },
    ],
  },
  {
    title: "APIs & apps on-prem",
    links: [
      { name: "E-Invoicing dev", url: gc("einvoice-dev") },
      { name: "Internal API Swagger (dev)", url: gc("internalapi-re", "/swagger/index.html"), note: "internalapi-re points to the dev container", verify: true },
      { name: "Internal API Swagger (prod)", url: "http://10.192.193.3:44369/swagger/index.html", note: "dev-003 – no proxy host, internal", verify: true },
      { name: "Janitza API Swagger", url: "http://10.192.193.3:5000/swagger/index.html", note: "dev-003 – internal", verify: true },
      { name: "ERP gateway PROD", url: gc("erpgwpr", "/graphql") },
      { name: "ERP gateway RE", url: gc("erpgwre", "/graphql") },
      { name: "atgolosdev1", url: gc("dev1"), note: "Forward to 192.168.66.1:4444" },
      { name: "atgolosdev2", url: gc("dev2"), note: "Forward to 192.168.66.2:3000" },
    ],
  },
  {
    title: "Cloud",
    links: [
      { name: "Azure DevOps", url: "https://dev.azure.com/GenesisCloudApps1/" },
      {
        name: "Azure Portal",
        url: "https://portal.azure.com/#@genesiscloud.onmicrosoft.com/dashboard/arm/subscriptions/1e24f37d-1083-48ea-827b-0e5dea4461cb/resourcegroups/dashboards/providers/microsoft.portal/dashboards/2cd446d0-5ac4-40d5-bce0-2b5aeff5305f",
        note: "Dashboard",
      },
    ],
  },
];
